import { mergeAttributes, Node } from '@tiptap/core';

/**
 * Block node that preserves a div with a custom class.
 * Use when you need <div class="my-class">...</div> to be retained during edit/save.
 * Only divs that have a class attribute are parsed as this node; plain divs are ignored.
 */
export const DivWithClass = Node.create({
  name: 'divWithClass',

  group: 'block',

  content: 'block+',

  addOptions() {
    return { HTMLAttributes: {} };
  },

  addAttributes() {
    return {
      class: {
        default: null as string | null,
        parseHTML: (element: HTMLElement) => {
          const cls = element.getAttribute('class');
          return cls && cls.trim() !== '' ? cls.trim() : null;
        },
        renderHTML: (attributes: { class?: string | null }) => {
          const cls = attributes.class;
          if (!cls || cls.trim() === '') return {};
          return { class: cls.trim() };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[class]',
        getAttrs: (dom: HTMLElement) => {
          const cls = dom.getAttribute('class');
          if (!cls || cls.trim() === '') return false;
          return { class: cls.trim() };
        },
      },
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    const cls = node.attrs.class;
    const attrs = { ...this.options.HTMLAttributes, ...HTMLAttributes };
    if (!cls || cls.trim() === '') {
      delete attrs.class;
    } else {
      attrs.class = cls.trim();
    }
    return ['div', mergeAttributes(attrs), 0];
  },
});

export default DivWithClass;
